<template>
    <div
        class="chat_dot_status"
        :style="active ? styleActive : styleInActive ">
    </div>
</template>

<script>
export default {
  name: 'DotStatus',
  props: {
    active: Boolean
  },
  data () {
    return {
      styleActive: {
        'background-color': 'green'
      },
      styleInActive: {
        'background-color': 'lightgray'
      }
    }
  }
}
</script>

<style lang="scss">
.chat_dot_status {
    width: 8px;
    height: 8px;
    border-radius: 4px;
}
</style>
